import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/blocks/components/register-section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/hafizalquran/src/blocks/components/VideoGallary/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_@types+_a6b223a3a93481ef912beb6084c0bd7d/node_modules/next/dist/client/app-dir/link.js");
